import { useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import {
  DSButton,
  ErrorMessage,
  InputLabel,
  PasswordStrengthMeter
} from "components/UI/atoms";
import { PasswordTooltipHint } from "components/UI/molecules";
import { usePasswordValidation } from "hooks/usePasswordValidation";
import { validationSchema } from "./utils/validationSchema";
import { useHandleChangePassword } from "./utils/useHandleChangePassword";
import "./index.scss";

export const ChangePasswordForm = () => {
  const {
    register,
    handleSubmit,
    formState: { errors, touchedFields },
    trigger,
    watch
  } = useForm({
    resolver: yupResolver(validationSchema)
  });
  const passwordValue = watch("password");
  const { passedValidations } = usePasswordValidation({ passwordValue });
  const { isLoading, saveNewPassword } = useHandleChangePassword();

  const onSubmit = async ({ password, confirmPassword }) => {
    await saveNewPassword({ password, passwordConfirmation: confirmPassword });
  };

  return (
    <form
      className="change-password-form"
      onSubmit={(e) => handleSubmit(onSubmit, () => trigger())(e)}
    >
      <div className="password-container">
        <div className="field-container">
          <InputLabel
            placeholder="Password"
            label="Password"
            id="password"
            type="password"
            hasError={!!errors.password}
            showValidationIcon={errors.password || touchedFields.password}
            {...register("password", { required: true })}
            onBlur={(e) => {
              register("password").onBlur(e);
              trigger("password");
            }}
            hintTooltip={<PasswordTooltipHint />}
            disablePopUp
            required
          />
          {!!errors.password && <ErrorMessage error={errors.password} />}
        </div>
        <PasswordStrengthMeter passwordScore={passedValidations} />
      </div>

      <div className="field-container">
        <InputLabel
          placeholder="Password"
          label="Confirm Password"
          id="confirmPassword"
          type="password"
          hasError={!!errors.confirmPassword}
          showValidationIcon={
            errors.confirmPassword || touchedFields.confirmPassword
          }
          {...register("confirmPassword", { required: true })}
          onBlur={(e) => {
            register("confirmPassword").onBlur(e);
            trigger("confirmPassword");
          }}
          disablePopUp
          required
        />
        {!!errors.confirmPassword && (
          <ErrorMessage error={errors.confirmPassword} />
        )}
      </div>

      <DSButton
        customClassName="submit-button"
        type="submit"
        variant="secondary"
        disabled={isLoading}
      >
        Update
      </DSButton>
    </form>
  );
};
